import React from 'react';
import Analytics from '../components/Analytics';

const AnalyticsPage = () => {
  return <Analytics />;
};

export default AnalyticsPage;
